import classes from "./social_buttons.module.css" 
import Google from '@/assets/svg/google-logo.svg';
import Facebook from '@/assets/svg/facebook-logo.svg';
import CustomSVG from "@/components/common/svg";
import { signIn } from "next-auth/react";

export default function SocialButtons({redirectURL}) {

    const popup = (url) => {
        const dualScreenLeft = window.screenLeft ?? window.screenX;
        const dualScreenTop = window.screenTop ?? window.screenY;
        const width =
          window.innerWidth ?? document.documentElement.clientWidth ?? screen.width;
    
        const height =
          window.innerHeight ??
          document.documentElement.clientHeight ??
          screen.height;
    
        const systemZoom = width / window.screen.availWidth;
    
        const left = (width - 500) / 2 / systemZoom + dualScreenLeft;
        const top = (height - 550) / 2 / systemZoom + dualScreenTop;
    
        const newWindow = window.open(
          url,
          'Google',
          `width=${500 / systemZoom},height=${550 / systemZoom
          },top=${top},left=${left}`
        );
    
        newWindow?.focus();
      };

    // const facebookLogin = async () => {
    //     const result = await signIn("facebook", {callbackUrl: (redirectURL ? redirectURL : "/szervezom")}, {prompt: "login"});
    // }


    return <div className={`${classes["btn-container"]}`}>
        <button className={`${classes["button"]}`} onClick={() => popup("/google-signin")}  type="button">
            <CustomSVG SvgFunction={Google} height={24} width={24} />
            <p className="padding-0 margin-0 color-gray-700 text-md-semibold">
                Google
            </p>
        </button>
        {/* <button className={`${classes["button"]}`} onClick={facebookLogin} type="button">
            <CustomSVG SvgFunction={Facebook} height={24} width={24} />
            <p className="padding-0 margin-0 color-gray-700 text-md-semibold">
                Facebook
            </p>
        </button> */}
    </div>
}